const firebaseConfig = {
  apiKey: 'AIzaSyBX-cOFKB6WZpHoacYAerQTlX9G9jpk_5A',
  authDomain: 'gem-2025.firebaseapp.com',
  projectId: 'gem-2025',
  storageBucket: 'gem-2025.firebasestorage.app',
  messagingSenderId: '765404437621',
  appId: '1:765404437621:web:f90097722b384666ceec3c',
  measurementId: 'G-CNJF29GC2L',
}

export default firebaseConfig
